import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./About.css";

import event from "../assets/event.jpg";
// Example image imports (replace with your actual image paths)
import FounderImage from "../assets/brik.png";
import InnovationImage from "../assets/briksupport.jpg";
import TodayImage from "../assets/brik.png";
import nahBro from "../assets/nahbrik.JPG";
const AboutUs = () => {
    return (
        <div>
            <Header />

            {/* Section 1: Meet the Founder */}
            <section className="about-section2 section-normal">
                <div className="about-text green-background2">
                    <h2>Meet the Founder</h2>
                    <h3>Asray Gopa</h3>
                    <p>
                        The Brik was born out of Asray Gopa’s desire to create a compact,
                        all-in-one organizational tool that simplifies everyday carry essentials.
                        Frustrated with juggling multiple items like a wallet, keys, and phone stand,
                        he sought to develop a sleek, durable, and multifunctional solution.
                    </p>
                </div>
                <div className="about-image2">
                    <img src={InnovationImage} alt="Asray with The Brik" />
                </div>
            </section>

            {/* Section 2: Innovation Behind The Brik */}
            <section className="about-section2 section-reverse">
                <div className="about-image2">
                    <img src={event} alt="Brik functionality" />
                </div>
                <div className="about-text green-background2">
                    <h2>Innovation Behind The Brik</h2>
                    <p> 
                        The Brik is a tool designed to keep daily essentials secure and accessible.
                        It includes features like a phone stand, key holder, stylus, foldable knife,
                        and a tracking chip, making it the perfect companion for students, professionals,
                        and travelers alike.
                        <br /><br />
                        Built with high-quality materials and a sleek design, The Brik is not just
                        about convenience—it’s a lifestyle upgrade.
                    </p>
                </div>
            </section>

            {/* Section 3: Today, Asray is */}
            <section className="about-section2 section-normal">
                <div className="about-text green-background2">
                    <h2>Today, Asray is</h2>
                    <p>
                        A junior at Iowa State University majoring in Computer Science with a minor
                        in Economics and Entrepreneurship. While leading The Brik, he is also involved
                        in multiple startup ventures, hackathons, and entrepreneurial competitions.
                    </p>
                </div>
                <div className="about-image2">
                    <img src={nahBro} alt="Asray at Iowa State" />
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default AboutUs;